import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { combos } from "@/mocks/solucoes";

const ACCENT: Record<"primary" | "accent" | "secondary", { icon: string; pill: string }> = {
  primary: { icon: "bg-primary-100/70 text-primary-600", pill: "bg-primary-50 text-primary-700" },
  accent: { icon: "bg-accent-100/70 text-accent-700", pill: "bg-accent-50 text-accent-700" },
  secondary: {
    icon: "bg-secondary-100/70 text-secondary-700",
    pill: "bg-secondary-50 text-secondary-700",
  },
};

export default function SolucoesCombos() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Combinações de serviços"
          badgeIcon="ri-stack-line"
          badgeTone="secondary"
          title="Monte a solução ideal para sua empresa"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {combos.map((combo, index) => {
            const acc = ACCENT[combo.accent];
            return (
              <Reveal key={combo.title} delay={(index % 4) * 60} className="h-full">
                <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-100/60 p-6 transition-colors hover:border-primary-300">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${acc.icon}`}>
                    <i className={`${combo.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                    {combo.title}
                  </h3>
                  <p className="mt-1 text-xs uppercase tracking-wide text-foreground-500">
                    {combo.subtitle}
                  </p>
                  <ul className="mt-5 flex flex-1 flex-wrap gap-2">
                    {combo.items.map((item) => (
                      <li
                        key={item}
                        className={`rounded-full px-3 py-1 text-xs font-medium ${acc.pill}`}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 flex flex-col items-center gap-6 rounded-2xl border border-background-200 bg-background-100/60 px-6 py-8 text-center md:px-10">
            <p className="max-w-3xl text-base leading-relaxed text-foreground-600">
              Cada negócio possui necessidades diferentes. Fale com a NXHOST e descubra quais
              soluções fazem sentido para o seu projeto.
            </p>
            <a
              href={whatsappLink(
                "Ola! Quero montar a solucao ideal para a minha empresa com a NXHOST.",
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-tools-line text-lg" aria-hidden="true"></i>
              Montar minha solução
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}